import { render, staticRenderFns } from "./PrevOrders.vue?vue&type=template&id=1a704a34&scoped=true"
import script from "./PrevOrders.vue?vue&type=script&lang=js"
export * from "./PrevOrders.vue?vue&type=script&lang=js"
import style0 from "./PrevOrders.vue?vue&type=style&index=0&id=1a704a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a704a34",
  null
  
)

export default component.exports